module.exports = __webpack_public_path__ + "public/img/tsTower.056f1b5e.png";